// Types and pure helpers for "Who manages this workspace?" (see useWorkspaceContacts).

export interface WorkspaceContact {
    personId: string;
    name: string;
    email?: string | null;
    jobTitle?: string | null;
    teams: string[];
    sharesYourTeam: boolean;
}

export interface WorkspaceContactGroup {
    /** CustomerRole name, e.g. "SupportContact". */
    role: string;
    label: string;
    description: string;
    /** Everyone holding the role; `people` may be the first few (maintainers are capped). */
    total: number;
    people: WorkspaceContact[];
}

/** "Showing the first 25 of 40" when a group is capped; null when everyone is listed. */
export const cappedListNote = (group: WorkspaceContactGroup): string | null =>
    group.total > group.people.length
        ? `Showing the first ${group.people.length} of ${group.total}, those sharing your teams first.`
        : null;
